export default "__VITE_ASSET__DrL29Tw9__"